import Rollbar from 'rollbar';

const IGNORED_ERRORS = [
  'Registration failed - push service error',
  'Registration failed - permission denied',
  `Cannot read properties of undefined (reading 'subscribe')`,
  'Network Error',
  'Request aborted',
  'Your card number is incorrect.',
];

function _isIgnoredResponseStatus(error) {
  if (!error || !error.response || !error.response.status) return false;

  switch (error.response.status) {
  case 401:
  case 403:
  case 404:
  case 422:
  case 500:
    return true;
  default:
    return false;
  }
}

function _isInvalidFileUpload(msg) {
  if (typeof msg !== 'string') return false;

  return msg.startsWith('Error creating Blob for ');
}

function _isStorageError(msg) {
  // Example:
  // Error storing "Zainab Rizwan 1.mp4". Status: 0

  const prefix = 'Error storing ';
  const suffix = '. Status: 0';

  return msg.startsWith(prefix) && msg.endsWith(suffix);
}

function _shouldIgnoreError(error, errorMsg) {
  if (!error && !errorMsg) return true;

  if (_isIgnoredResponseStatus(error)) return true;

  if (_isInvalidFileUpload(error)) return true;

  if (!!error && !error.message) return false;

  const msg = (error && error.message) || errorMsg;

  if (IGNORED_ERRORS.includes(msg)) return true;

  if (_isStorageError(msg)) return true;

  return false;
}

class RollbarLogger {
  constructor() {
    /* istanbul ignore next */
    if (process.env.NODE_ENV === 'development') return;

    /* istanbul ignore next */
    if (!process.env.ROLLBAR_CLIENT_TOKEN) return;

    /* istanbul ignore next */
    this._rollbar = new Rollbar({
      accessToken: process.env.ROLLBAR_CLIENT_TOKEN,
      captureUncaught: false,
      captureUnhandledRejections: false,
      hostSafeList: [ 'reedsy.com' ],
      payload: {
        environment: process.env.RAILS_ENV,
      },
    });
  }

  error(err, errorMsg = null, additionalInfo = null) {
    if (!this._rollbar) return;

    if (_shouldIgnoreError(err, errorMsg)) return;

    if (!!errorMsg) {
      this._rollbar.error(errorMsg, err);
      return;
    }

    if (!!additionalInfo) {
      this._rollbar.error(err, additionalInfo);
      return;
    }

    this._rollbar.error(err);
  }
}

export default new RollbarLogger();
